import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';
import { GamesQuestionsService } from './questions-services/games-questions.service';
import { GamesListComponent } from './games-list/games-list.component';
import { GamesComponent } from './games/games.component';
import { GamesRoutingModule } from './games-routing.module';
import { GameEditorComponent } from './game-editor/game-editor.component';
import { GameDetailComponent } from './game-detail/game-detail.component';
import { GameCreateComponent } from './game-create/game-create.component';
import { TopicsService } from './topics.service';

@NgModule({
  imports: [CommonModule, CoreModule, GamesRoutingModule],
  declarations: [GamesListComponent, GamesComponent, GameEditorComponent, GameDetailComponent, GameCreateComponent],
  exports: [],
  providers: [GamesQuestionsService, TopicsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GamesModule {}
